import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';


@Component({
  selector: 'app-quote-details',
  templateUrl: './quote-details.component.html',
  styleUrls: ['./quote-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class QuoteDetailsComponent implements OnInit {
  readonly data = input(undefined);

  get listKeys() {
    const data = this.data();
    if(!data) return
    let keys = Object.keys(data);
    const indexFrom = keys.findIndex(item => item == 'ICAO');

    return keys.slice(0, indexFrom);
  }

  constructor() { }

  ngOnInit() {
  }

}
